/* eslint-disable */
enum ButtonVariants {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  GRADIENT = 'gradient',
}
/* eslint-enable */
export default ButtonVariants
